import React from "react";
import ReactECharts from "echarts-for-react";
import { grey, blue, green } from "@material-ui/core/colors";

export default function PendingSacksGraph({ data }) {
  // Sort data by date and filter
  const sortedData = [...data]
    .filter((x) => x.bagsPendingGrading)
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  // Format dates as dd-MM-yyyy
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const dates = sortedData.map((item) => formatDate(item.createdAt));
  const totalBags = sortedData.map((item) =>
    Math.round(item.bagsPendingGrading),
  ); // in 'mil sacas'

  const option = {
    title: {
      text: "Sacos Pendentes",
      left: "center",
      textStyle: { color: grey[400] },
    },
    tooltip: {
      trigger: "axis",
    },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: { rotate: 45 },
    },
    yAxis: {
      type: "value",
      name: "Mil sacas",
    },
    series: [
      {
        name: "Sacos Pendentes",
        type: "line",
        data: totalBags,
        smooth: true,
        lineStyle: { width: 2, color: blue[400] },
        itemStyle: { color: green[500] },
      },
    ],
    grid: { left: "10%", right: "10%", bottom: "20%" },
    toolbox: { feature: { saveAsImage: {}, restore: {} } },
  };

  return (
    <div style={{ height: "500px", width: "100%", marginTop: 20 }}>
      <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
    </div>
  );
}
